import {
  Months,
  PaymentReceiptsLabels,
  PaymentReceiptsTypes,
  PixKeyLabel,
  PixKeyType,
  PurchaseReceiptsLabels,
  PurchaseReceiptsTypes,
} from './interfaces';

export const paymentTypes = [
  PaymentReceiptsTypes.Payment,
  PaymentReceiptsTypes.BillingStatement,
  PaymentReceiptsTypes.Other,
];

export const purchaseReceiptsOptions = [
  { label: PurchaseReceiptsLabels.Nfe, value: PurchaseReceiptsTypes.Nfe },
  { label: PurchaseReceiptsLabels.Sale, value: PurchaseReceiptsTypes.Sale },
  { label: PurchaseReceiptsLabels.Ticket, value: PurchaseReceiptsTypes.Ticket },
  {
    label: PurchaseReceiptsLabels.Invoice,
    value: PurchaseReceiptsTypes.Invoice,
  },
  { label: PurchaseReceiptsLabels.Billet, value: PurchaseReceiptsTypes.Billet },
];

export const paymentReceiptsOptions = [
  { label: PaymentReceiptsLabels.Payment, value: PaymentReceiptsTypes.Payment },
  {
    label: PaymentReceiptsLabels.BillingStatement,
    value: PaymentReceiptsTypes.BillingStatement,
  },
];

export const monthsOptions = [
  { label: Months.January, value: 1 },
  { label: Months.February, value: 2 },
  { label: Months.March, value: 3 },
  { label: Months.April, value: 4 },
  { label: Months.May, value: 5 },
  { label: Months.June, value: 6 },
  { label: Months.July, value: 7 },
  { label: Months.August, value: 8 },
  { label: Months.September, value: 9 },
  { label: Months.October, value: 10 },
  { label: Months.November, value: 11 },
  { label: Months.December, value: 12 },
];

export const pixKeyTypeOptions = [
  { label: PixKeyLabel.Cpf, value: PixKeyType.Cpf },
  { label: PixKeyLabel.Email, value: PixKeyType.Email },
  { label: PixKeyLabel.Phone, value: PixKeyType.Phone },
  { label: PixKeyLabel.Random, value: PixKeyType.Random },
];
